// You can customize the template with the help of this file
//Template config options
const themeConfig = {
  app: {
    appName: '',
    appLogoImage: require('@src/assets/images/logo/amrak.png').default,
    appLogoImageOld: require('@src/assets/images/logo/amrakold.png').default,
    appLogoSide: require('@src/assets/images/logo/amrakImg.png').default,
    appLogoDarkImage: require('@src/assets/images/logo/amrak.png').default,
    appLogoFavImage: require('@src/assets/images/logo/logo_small.png').default,
    loginBgImage: require('@src/assets/images/pages/login-background.png').default,
    loginBtnImage: require('@src/assets/images/pages/ms-signIn-btn.png').default
  },

    // to change theme color
    // *update below primary color,
    // *@core->scss->base->bootstrap-extended->_variable (29 line)
    // *@core->scss->base->bootstrap-extended->_card (194 line)
    // *@core->scss->base->pages->authentication (14 line)
    // *@core->scss->base->pages->page_auth (13 line)
  color:{
    primary:'#42506B'
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'boxed', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  }
}

export default themeConfig
